export const en = {
  users: 'users',
  users_table: 'users table',
  permission_groups: 'permission groups',
  active: 'active',
  name: 'name',
  block: 'blocked',
  block_action: 'block',
  permission_group: 'permission group',
  permission_group_required: 'Permission Group is Required',
  search_by_permission: 'search by permission',
  number_of_users: 'No. of users',
  number_of_permissions: 'No. of permissions',
  blocked_users: 'blocked users',
  active_users: 'active users',
  trashed_users: 'trashed users',
  top_productive_users: 'top productive users',
  users_status: 'users/status',
  total_num_users: 'total number of users',
  add_permission: 'add new permission',
  edit_permission: 'edit permission',
  add_new_user: 'add new user',
  user_name: ' user name',
  personal_info: 'personal info',
  search_permission: 'Search By Permission',
  permission_name: 'permission name',
  description: 'description',
  search_by_username: 'search by name',
  achievements: 'achievements',
  email_input: 'email*',
  email_error: 'email must be unique',
  cancel_create: 'Are you Sure you want to cancel creating the permission?',
  cancel_edit: 'Are you Sure you want to cancel editing the permission?',
  permission_created: 'Permission Group Added Successfully',
  permission_updated: 'Edit done Successfully ',
  add_users: 'add users',
  number_of_hashtags: 'number of hashtags',
  number_of_sets: 'number of sets',
  number_of_news_sources: 'number of news source editions',
  number_of_bookmark: 'number of bookmark',
  number_of_channels: 'number of channels',
  number_of_entities: 'number of entities',
  number_of_reports: 'number of reports',
  number_of_influencers: 'number of influencers',
  user_permission: 'Users/permission group',
  user_permission_tooltip: 'Permission users',
  avg_logged_hours: 'Average logged hours',
  last_seen: 'last seen',
  user_profile: 'user profile',
  user_activities: "user's activities",
  address: 'Address',
  security: 'Security',
  added_new_user: 'User Added Successfully , Go To ',
  are_you_sure_you_want_to_cancel_edit_user:
    'Are you Sure you want to cancel editing the user? ',
  are_you_sure_you_want_to_cancel_add_user:
    'Are you Sure you want to cancel creating the user?',
  all: 'all',
  user_updated: ' User Edited Successfully , Go To ',
  searchBy_name: 'search by name',
  logs: 'logs',
  created_hashtags: 'created hashtags',
  created_tweets: 'created tweets',
  created_instagram_posts: 'created instagram posts',
  created_tiktok_posts: 'created tiktok posts',
  created_linkedin_posts: 'created linkedin posts',
  created_sets: 'created sets',
  created_reports: 'created reports',
  created_channels: 'created channels',
  created_influencers: 'created influencers',
  created_new_sources: 'created sources editions',
  created_videos: 'created videos',
  report_name: 'report name',
  channel_name: 'channel name',
  influencer_name: 'influencer name',
  new_source: 'new source',
  activity: 'activity',
  module: 'module',
  user_productivity: "user's productivity",
  email: 'email',
  date: 'DD/MM/YYYY',
  password_error: 'password is required',
  Address_is_mandatory: 'Address is mandatory',
  this_field_is_mandatory: 'this field is mandatory',
  Name_Is_Required: 'Name Is Required',
  Email_Is_Required: 'Email Is Required',
  No_password_provided: 'No password provided.',
  Password_is_too_short: 'Password is too short - should be 8 chars minimum.',
  Password_message: 'Password can only contain Latin letters.',
  Passwords_must_match: 'Passwords must match',
  Disable: 'Disable two-factor authentication via email address',
  First_Step_authentication: 'First Step authentication',
  Second_Step_authentication: 'Second Step authentication',
  select_new_permission: 'select new permission',
  select__permission: 'select permission',
  permission: 'permission',
  unique_email: 'email must be unique',
  edit_user: 'Edit User',
  permission: 'Permission',
  number_of_topics: 'Number of topics',
  created_topics: 'Created topics',
  number_of_videos: 'Number of videos',
  number_of_organizations: 'Number of organizations',
  topic_name: 'Topic name',
  user: 'User',
  select_the_permission: 'Please select the permission group',
  select_permission: 'Select Permission Group',
  permission_min_validation: 'Permission name must be at least 2 characters',
  desc_min_validation: 'Permission description must be at least 2 characters',
  sorry_permitted_for_the_user:
    'sorry , That  action is not permitted for the user',
  passwprd: 'Password',
  Password_message_numbers_letters:
    'Password must contain numbers and Latin letters.',
  Password_message_letters: 'Password must contain lower and upper letters.',
  Password_message_number: 'Password must contain numbers.',
  Password_message_special: 'Password must contain special character.',
  password_should_have: 'Password Should have ',
  at_least_8_characters: 'Be a minimum of 8 characters',
  letters_and_numbers: 'letters and numbers',
  lowerCase_and_upperCase: 'LowerCase and UpperCase',
  special_character: 'Include at least one special character',
  The_permissions_of_this_group_cannot_be_changed:
    'The permissions of this group cannot be changed',
  users_ids_required: 'users must be at least one user selected',
  View: 'View',
  your_password_must: 'Your Password Must',
  lowerCase: 'Include at least one lowercase letter (a-z)',
  upperCase: 'Include at least one uppercase letter (A-Z)',
  number: 'Include at least one number (0-9)',
  passwordـisـrequired: 'password is required',
  rest_password: 'Reset your password',
  no_confirm_password_provided: 'no confirm password provided',
};

export const ar = {
  no_confirm_password_provided: 'لم يتم تقديم تاكيد كلمة مرور ',
  View: 'عرض',
  users_ids_required: 'يجب أن يتم تحديد مستخدم واحد على الأقل ',
  The_permissions_of_this_group_cannot_be_changed:
    'لا يمكن تغيير صلاحيات هذه المجموعة',
  passwprd: 'كلمة مرور',
  permission: 'اذن',
  select_new_permission: 'حدد صلاحية جديده',
  select__permission: 'حدد صلاحية',
  First_Step_authentication: 'مصادقة الخطوه الأولى',
  Second_Step_authentication: 'مصادقة الخطوه الثانية',
  Disable: 'تعطيل المصادقة الثنائية عبر عنوان البريد الإلكتروني',
  Passwords_must_match: 'كلمة المرور غير متطابقه',
  Password_message: 'يجب أن تحتوي كلمة المرور على أحرف لاتينية فقط.',
  Password_is_too_short: 'كلمة المرور قصيرة جدًا - يجب ألا تقل عن 8 أحرف.',
  No_password_provided: 'لم يتم تقديم كلمة مرور',
  Name_Is_Required: 'الاسم مطلوب',
  Email_Is_Required: 'البريد الإلكتروني مطلوب',
  this_field_is_mandatory: 'هذا الحقل مطلوب',
  Address_is_mandatory: 'العنوان مطلوب',
  date: 'يوم/شهر/سنه',
  password_error: 'الباسورد مطلوب',

  email: 'البريد الإلكتروني',
  are_you_sure_you_want_to_cancel_add_user:
    'هل انت متأكد من إلغاء عملية إضافة مستخدم جديد',
  address: 'العنوان',
  security: 'الحمايه',
  user_updated: ' تم تعديل المستخدم بنجاج , إذهب إلى  ',
  email_input: 'البريد الإلكتروني*',
  email_error: 'البريد الإلكتروني مستخدم بالفعل.',
  add_new_user: ' إضافة مستخدم جديد',
  added_new_user: ' تم إضافة المستخدم بنجاج , إذهب إلى ',
  permission_group: 'مجموعة الصلاحيات',
  permission_group_required: ' مجموعة الصلاحيات مطلوبة',

  achievements: 'الإنجازات',
  unique_email: 'الإيميل يجب ان يكون مميز',
  user_name: ' اسم المستخدم',
  edit_user: 'تعديل المستخدم ',
  active: 'نشط',
  name: 'الإسم',
  block: 'حظر',
  users: 'المستخدمون',
  users_table: 'جدول المستخدمين',
  permission_groups: 'مجموعات الصلاحيات',
  search_by_permission: 'بحث بالاذن',
  search_by_username: 'بحث بالاسم ',
  number_of_users: 'عدد المستخدمين',
  number_of_permissions: 'عدد الاذونات',
  blocked_users: 'المستخدمون المحظورون',
  active_users: 'المستخدمون النشطون',
  trashed_users: 'المستخدمون المحذوفون',
  top_productive_users: 'أكثر المستخدمين نشاطاً',
  users_status: 'المستخدم/الحالة',
  total_num_users: 'مجموع المستخدمين',
  add_permission: 'إضافة مجموعة اذن جديدة',
  edit_permission: 'تعديل مجموعة الاذن',
  personal_info: 'بيانات شخصية',
  search_permission: 'بحث بالاذن',
  permission_name: 'اسم الاذن',
  description: 'الوصف',
  cancel_create: 'هل أنت متأكد انك تريد الغاء أنشاء الاذن؟',
  cancel_edit: 'هل أنت متأكد انك تريد الغاء تعديل الاذن؟',
  edit: 'هل أنت متأكد انك تريد الغاء تعديل الاذن؟',
  permission_created: 'تم أنشاء الاذن بنجاح',
  permission_updated: 'تم التعديل بنجاح',
  added_users: 'إضافة المستخدمين',
  number_of_hashtags: 'عدد الهاشتاقات',
  number_of_sets: 'عدد المجموعات',
  number_of_news_sources: 'عدد إصدارات مصادر الأخبار',
  number_of_bookmark: 'عدد العلامات',
  number_of_channels: 'عدد القنوات',
  number_of_entities: 'عدد الكيانات',
  number_of_reports: 'عدد التقارير',
  number_of_influencers: 'عدد المؤثرين',
  number_of_videos: 'عدد الفيديوهات',
  number_of_organizations: 'عدد المؤسسات',
  user_permission: 'المستخدمون / مجموعة الصلاحيات',
  user_permission_tooltip: 'مستخدمين الصلاحية',
  avg_logged_hours: 'متوسط ساعات العمل',
  last_seen: 'اخر ظهور',
  user_profile: 'الملف الشخصي',
  user_activities: 'أنشطة المستخدم',
  all: 'الجميع',
  searchBy_name: 'بحث بالاسم',
  logs: 'السجلات',
  created_hashtags: ' الهاشتاقات المنشأة',
  created_tweets: 'التغريدات المنشأة ',
  created_instagram_posts: 'منشورات الانستقرام المنشأة',
  created_tiktok_posts: 'منشورات تيك توك المنشأة',
  created_linkedin_posts: 'منشورات لينكد ان المنشأة',
  created_sets: 'المجموعات المنشأة',
  created_reports: 'التقارير المنشأة',
  created_channels: 'القنوات المنشأة',
  created_influencers: 'المؤثرون المنشأة',
  created_new_sources: 'إصدارات المصادر المنشأة ',
  created_videos: 'الفيديوهات المشأة',
  report_name: 'اسم التقرير',
  channel_name: 'اسم القناة',
  influencer_name: 'اسم المؤثر',
  new_source: 'المصدر الجديد',
  activity: 'النشاط',
  module: 'الفرع',
  user_productivity: 'انتاج المستخدم',
  permission: 'إذن',
  add_users: 'إضافة مستخدمين',
  number_of_topics: 'عدد الموضوعات',
  created_topics: 'المواضيع المنشأة',
  topic_name: 'اسم الموضوع',
  user: 'مستخدم',
  select_the_permission: 'من فضلك اختر مجموعة الصلاحيات',
  select_permission: 'اختر مجموعة صلاحيات',
  permission_min_validation: 'يجب ألا يقل اسم الإذن عن حرفين',
  desc_min_validation: 'يجب ألا يقل وصف الإذن عن حرفين',
  block_action: 'حظر',
  sorry_permitted_for_the_user: 'عفوا ، هذا الإجراء غير مسموح لهذا المستخدم',
  are_you_sure_you_want_to_cancel_edit_user:
    'هل انت متأكد انك تريد الغاء تعديل المستخدم ؟',
  are_you_sure_you_want_to_cancel_add_user:
    'هل انت متأكد انك تريد الغاء إضافة المستخدم ؟',
  Password_message_numbers_letters:
    'يجب أن تحتوي كلمة المرور على أرقام و احرف لاتينية.',
  Password_message_letters: 'كلمة المرور يجب ان تحتوى على احرف لاتينية',
  Password_message_number: 'كلمة المرور يجب ان تحتوى على أرقام',
  Password_message_special: 'كلمة المرور يجب ان تحتوى على حرف خاص',
  password_should_have: ' كلمة المرور يجب ان تحتوى على ',
  at_least_8_characters: ' 8 أحرف على الأقل ',
  letters_and_numbers: ' أحرف وأرقام ',
  lowerCase_and_upperCase: ' أحرف صغيرة وكبيرة ',
  special_character: 'قم بتضمين حرف خاص واحد علي الأقل',
  your_password_must: 'يجب أن تكون كلمة المرور الخاصة بك',
  lowerCase: 'قم بتضمين حرف صغير واحد على الأقل (a-z)',
  upperCase: 'قم بتضمين حرف كبير واحد على الأقل (A-Z)',
  number: 'قم تضمين رقم واحد على الأقل (0-9)',
  passwordـisـrequired: 'كلمة المرور مطلوبه',
  rest_password: 'إعادة تعيين كلمة المرور',
};
